import { Link } from 'react-router-dom';
import d5 from './Mainnav.module.css'; //scoped css only used for this file
import { useState ,useEffect ,useContext} from 'react';
import AccountInfo from './menu/AccountInfo';
import MenuContent from './menu/MenuContent';
import FooterMenuContent from './menu/FooterMenuContent';
import MenuIcon from './menu/MenuIcon';
import React from 'react';

import tanqLogo from '../media/questa logo.png'

import { BsQuestionCircle } from 'react-icons/bs';
import { AiOutlineFileDone } from 'react-icons/ai'
import { auth } from '../../firebase';
import DownloadPwaButton,{PWA_install_state} from '../ui/DownloadPwaButton';
import NotificationPermissionHandler from '../NotificationPermissionHandler';
import UserContext from '../../store/UserContext';

function Mainnav(props) {

        const userCtx = useContext(UserContext);



        // const [show, setShow] = useState(true);
        // const [lastScrollY, setLastScrollY] = useState(0);

        // const controlNavbar = () => {
        //         if (typeof window !== 'undefined') {
        //                 if (window.scrollY > lastScrollY) { // if scroll down hide the navbar
        //                         setShow(false);
        //                 } else { // if scroll up show the navbar
        //                         setShow(true);
        //                 }

        //                 // remember current page location to use in the next move
        //                 setLastScrollY(window.scrollY);
        //         }
        // };

        // useEffect(() => {
        //         if (typeof window !== 'undefined') {
        //                 window.addEventListener('scroll', controlNavbar);

        //                 // cleanup function
        //                 return () => {
        //                         window.removeEventListener('scroll', controlNavbar);
        //                 };
        //         }
        // }, [lastScrollY]);


         const [isOpen, setIsOpen] = useState(false);
         const handleToggle = () => { setIsOpen(!isOpen) };


         function pageSelectedColor(path){
                return userCtx.selectedPath===path?'#0C99FF':''
         }

        return (<div className={''//!isOpen?(show?d5.active:d5.hidden):null
        }>


                
                <MenuIcon state={isOpen} onClick={() => handleToggle()} />
                <div className={isOpen ? d5.opened : d5.closed}>
                        <div className={d5.backdrop} onClick={() => handleToggle()} />
                        <div className={d5.menu} >
                                <div ><img alt='logo' className={d5.logo} src={tanqLogo || 'https://firebasestorage.googleapis.com/v0/b/tanq-7bdfc.appspot.com/o/media%2Ftanq%20logo.png?alt=media&token=6fb15bec-3125-4f09-81eb-9c826cec46a1'} /></div>
                               
                                {auth.currentUser && <AccountInfo onClick={() => handleToggle()} />}
                                <DownloadPwaButton />
                                <NotificationPermissionHandler />
                                <MenuContent onClick={() => handleToggle()} />
                                <FooterMenuContent onClick={() => handleToggle()} />
                                <center style={{color:'#555',fontSize:'11px',margin:'20px 0'}}>v 2.0.2temp</center>
                        </div>
                </div>




                <header className={d5.header}>
                        <img alt='logo' className={d5.logoMain} src={tanqLogo} />
                        <nav>
                                <ul  >
                                        <li ><Link to="/ask" style={{color:pageSelectedColor("/ask")}}> <span>Ask</span><BsQuestionCircle size='20' /></Link></li>
                                        <li className={d5.verticalLine} >l</li>
                                        <li><Link 
                                        style={{color:pageSelectedColor('/answered'),
                                        'marginRight': '0px' }} to='/answered'>
                                                <span>Answered</span><AiOutlineFileDone size='23' />{userCtx.unreadAnswers !== 0 && <div className={d5.unreadBadge}>{userCtx.unreadAnswers}</div>}</Link></li>
                                </ul>
                        </nav>
                        <div className={d5.pwaButton} > <DownloadPwaButton />
                        </div>
                       
                </header>
                <div className={d5.backheader}></div>
        </div>);
}
export default Mainnav;
//links are like <a>  but doesn't require new server request
